module.exports = __webpack_public_path__ + "static/sarah-580c9242d8b6c59dff0bab3948fbbc69.png";